module.exports = __webpack_public_path__ + "static/media/et.74215308.svg";